<template>
 <div class="hero is-fullheight-with-navbar">
    <div class="hero-body">
      <div class="container">
	<h1 class="title" :aria-label="$t('Search Finnish Court Records')"  style="color: white;">{{ $t('Search Finnish Court Records') }}</h1>
	<h2 class="subtitle" :aria-label="$t('Search and browse district court notification records from 1810 to 1870.')"  style="color: white;">{{ $t('Search and browse district court notification records from 1810 to 1870.') }}</h2>
	<div class="columns">
	  <div class="column is-two-fifths">
	    <div class="box">
	      <form  @submit.prevent="gotoSearch">
          <b-field>
            <b-input
              v-on:keyup.enter="gotoSearch"
              v-model="queryTerm"
              :expanded="true"
              :placeholder='$t("Search...")'
              type="search"
              icon="search"
              :aria-label="$t('Search...')"
            ></b-input>
            <p class="control">
              <b-button  type="is-primary" @click="gotoSearch">{{ $t("Search") }}</b-button>
            </p>
          </b-field>
        </form>
	    </div>	    
	  </div>
	</div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
 @import '@/assets/variables.scss';
 @import 'bulma/sass/utilities/initial-variables.sass';

 /* NOTE: https://github.com/nuxt/nuxt.js/issues/4544#issuecomment-451700960 */
 .hero {
   @media screen and (max-width: $tablet) {
     background-image: url('~@/assets/background-769.jpg');
   }

   @media screen and (min-width: $tablet) and (max-width: $desktop) {
     background-image: url('~@/assets/background-960.jpg');
   }

   @media screen and (min-width: $desktop) and (max-width: $widescreen) {
     background-image: url('~@/assets/background-1152.jpg');
   }

   @media screen and (min-width: $widescreen) and (max-width: $fullhd) {
     background-image: url('~@/assets/background-1344.jpg');
   }

   @media screen and (min-width: $fullhd) {
     background-image: url('~@/assets/background-1920.jpg');
   }

   background-repeat: no-repeat;
   background-size: cover;
   background-position: center;
   position: relative;

   &::before {
     position: absolute;
     display: block;
     content: '';
     top: 0;
     left: 0;
     width: 100%;
     height: 100%;

     background: linear-gradient(200deg, rgba($primary, 0.0375) 35%, black);
   }

   .title,
   .subtitle {
     text-shadow: 0 0 20px rgba(0, 0, 0, 1), 0 0 40px rgba(0, 0, 0, 1), 0 0 2px rgba(0, 0, 0, 1);
   }

   .box {
     flex: 0;
     padding: 0;
     background-color: rgba(0, 0, 0, 0.375);
     box-shadow: -5px 5px 10px rgba(0, 0, 0, 0.5), -10px 10px 40px rgba(0, 0, 0, 0.5);
   }
 }
</style>
<script>
 import InfoBox from '@/components/InfoBox.vue'

 import { createMapper } from '@/utils/mapping.js'
 const mapper = createMapper('search-form')

 export default {
   components: {
     InfoBox
   },
   computed: {
     query() {
       return mapper.toURL({ term: this.term })
     },
     searchQuery() {
      return mapper.toURL({
        term: this.queryTerm,
      });
    },
    searchPageRoute() {
      // FIXME: use from global definition
      return {
        name: "Search",
        query: this.searchQuery,
      };
    },
   },
   data() {
     return { term: '', queryTerm: '' }
     
   },
   methods: {
    gotoSearch() {
      this.$router.push(this.searchPageRoute);
    },
  },
 }
</script>
